const _excluded = ["dataId", "value", "inputProps", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Checkbox } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export let IndeterminateCheckboxValue = /*#__PURE__*/function (IndeterminateCheckboxValue) {
  IndeterminateCheckboxValue[IndeterminateCheckboxValue["Unchecked"] = 0] = "Unchecked";
  IndeterminateCheckboxValue[IndeterminateCheckboxValue["Indeterminate"] = 1] = "Indeterminate";
  IndeterminateCheckboxValue[IndeterminateCheckboxValue["Checked"] = 2] = "Checked";
  return IndeterminateCheckboxValue;
}({});
export const IndeterminateCheckbox = _ref => {
  let {
      dataId,
      value,
      inputProps,
      onChange
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const handleOnSelect = () => {
    const newSelectState = (value + 1) % 3;
    onChange(newSelectState);
  };
  const {
    isChecked,
    isIndeterminate
  } = getStateByValue(value);
  return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, rest), {}, {
    onChange: handleOnSelect,
    checked: isChecked,
    indeterminate: isIndeterminate,
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      'data-id': dataId
    })
  }));
};
const getStateByValue = value => {
  switch (value) {
    case IndeterminateCheckboxValue.Unchecked:
      return {
        isIndeterminate: false,
        isChecked: false
      };
    case IndeterminateCheckboxValue.Indeterminate:
      return {
        isIndeterminate: true,
        isChecked: false
      };
    case IndeterminateCheckboxValue.Checked:
      return {
        isIndeterminate: false,
        isChecked: true
      };
  }
};